export default "__VITE_ASSET__974a3020__"